import { useEffect, useState } from "react";
import api from "../services/api.tsx";
import { useError } from "../contexts/ErrorContext.tsx";
import { useSuccess } from "../contexts/SuccessContext.tsx";

const ProfilePage = () => {
  const { setError } = useError();
  const { addSuccess } = useSuccess();

  const [formData, setFormData] = useState({
    id: "",
    fullName: "",
    email: "",
    phoneNumber: "",
    address: "",
    userType: "Bireysel"
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const res = await api.get("/api/user/profile", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFormData(res.data);
      } catch (error) {
        setError(error.response?.data?.Message || "Kullanıcı bilgileri alınamadı.");
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [setError]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("access_token");
      await api.put("/api/user/profile", formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      addSuccess("Profiliniz güncellendi!");
    } catch (error) {
      setError(error.response?.data?.Message || "Profil güncellenemedi.");
    }
  };

  if (loading) return <div className="p-8">Yükleniyor...</div>;

  return (
    <div className="max-w-xl mx-auto p-8 bg-white rounded shadow">
      <h2 className="text-2xl font-bold mb-6">Profil Bilgilerim</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="fullName"
          placeholder="Ad Soyad"
          value={formData.fullName}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="E-posta"
          value={formData.email}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          disabled
        />
        <input
          type="tel"
          name="phoneNumber"
          placeholder="Telefon"
          value={formData.phoneNumber}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          required
        />
        <input
          type="text"
          name="address"
          placeholder="Adres"
          value={formData.address}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          required
        />
        <select
          name="userType"
          value={formData.userType}
          onChange={handleChange}
          className="w-full border p-2 rounded"
        >
          <option value="Bireysel">Bireysel</option>
          <option value="Kurumsal">Kurumsal</option>
        </select>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Kaydet
        </button>
      </form>
    </div>
  );
};

export default ProfilePage;
